import {
	RetirementDropNoteType,
	RetirementDropSource,
} from "web_myplann/Inspiration/Retirement/constants";
import type {
	RetirementPortfolioItem,
	RetirementUncheckedDrop,
} from "web_myplann/Inspiration/Retirement/Types/RetirementTypes";
import { getRetirementDropTiming } from "web_myplann/Inspiration/Retirement/Utils/getRetirementDropTiming";

export const mapRetirementLoanDrop = (
	item: RetirementPortfolioItem,
	retirementYear: number,
): RetirementUncheckedDrop => ({
	id: `portfolio-${item.id}`,
	label: { type: RetirementDropSource.Portfolio, name: item.name },
	amount: item.monthlyPayment,
	...(item.endYear === undefined
		? {
				deductible: false,
				note: { type: RetirementDropNoteType.UnknownEnd },
			}
		: getRetirementDropTiming(item.endYear, retirementYear)),
});
